import React, { useEffect, useState } from 'react';
import TotalLists from './TotalLists';
import MonthSales from './MonthSales';
import MonthTotalLists from './MonthTotalLists';
import MonthSalesCalendar from './MonthSalesCalendar';
import TotalListsSkeleton from './TotalListsSkeleton';
import { useRecoilValue } from 'recoil';
import storeInfo from '../../recoil/storeInfo/atom';
import { isMileageDisplayEnabled } from '@utils/mileageDisplay';
import { useDashBoardSummaryList } from '@hooks/dashboard/useDashBoardSummaryList';
import { format } from 'date-fns';

const DashBoardRightContainer = () => {
  const storeInfoState = useRecoilValue(storeInfo);
  const showMileage = isMileageDisplayEnabled(
    storeInfoState.currentStoreId,
    storeInfoState.storeLists,
  );
  const [month, setMonth] = useState(() => {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    date.setDate(1);
    return date;
  });
  const { getDashBoardListsLoading, salesData, activeTotalList, thisMonthData, serverError } =
    useDashBoardSummaryList(storeInfoState.currentStoreId, format(month, 'yyyy-MM'));

  useEffect(() => {
    setMonth(new Date());
  }, [storeInfoState]);

  if (serverError) {
    return <div>서버 에러가 발생했습니다. 잠시 후 다시 시도해주세요.</div>;
  }

  if (getDashBoardListsLoading) {
    return (
      <div className="dashboard_right_container">
        <TotalListsSkeleton />
      </div>
    );
  }

  if (!salesData || !activeTotalList || !thisMonthData) {
    return <div>No data available.</div>;
  }

  const { todaySales, yesterdaySales, lastMonthlySales, totalMonthlySales } = thisMonthData;

  const {
    monthlySalesByCard,
    monthlySalesByCash,
    monthlySalesByEtc,
    totalMonthlySales: activeTotalListTotalMonthlySales,
  } = activeTotalList;

  return (
    <div className="dashboard_right_container">
      <TotalLists
        todayDailySales={todaySales}
        yesterdayDailySales={yesterdaySales}
        totalMonthlySales={totalMonthlySales}
        lastMonthlySales={lastMonthlySales}
      />
      <div data-tour="month-board">
        <MonthSales
          month={month}
          setMonth={setMonth}
          excelData={salesData}
          showMileage={showMileage}
        />
        <MonthTotalLists
          totalMonth={activeTotalListTotalMonthlySales}
          card={monthlySalesByCard}
          cash={monthlySalesByCash}
          etc={monthlySalesByEtc}
          showMileage={showMileage}
        />
        <MonthSalesCalendar
          currentDate={month}
          monthSalesData={salesData}
          showMileage={showMileage}
        />
      </div>
    </div>
  );
};

export default DashBoardRightContainer;
